"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9912],{

/***/ 15813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29342);
var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 270 47",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M76.306 18.209c-.001-2.691-2.318-4.822-5.028-4.822h-6.052a.484.484 0 0 0-.486.483v8.939c0 .266.217.483.486.483h5.06c3.269 0 6.022-1.666 6.02-5.083m-2.317 9.625c-.232.051-.35.314-.219.51a10.31 10.31 0 0 0 8.09 4.564.338.338 0 0 1 .328.335v4.856c0 .19-.16.347-.351.34a15.884 15.884 0 0 1-14.274-10.023.338.338 0 0 0-.314-.215h-2.023a.484.484 0 0 0-.486.482v9.281a.485.485 0 0 1-.487.483h-4.66a.485.485 0 0 1-.486-.483V8.918c0-.267.218-.483.487-.483h10.993c6.063 0 11.61 3.202 11.61 9.734 0 5.42-3.601 8.634-8.208 9.665m164.66-4.393c0-5.597-4.586-10.15-10.223-10.15-5.638 0-10.224 4.553-10.224 10.15s4.586 10.15 10.224 10.15c5.637 0 10.223-4.553 10.223-10.15m5.528 0c0 8.623-7.066 15.639-15.751 15.639-8.686 0-15.752-7.016-15.752-15.64 0-8.622 7.066-15.638 15.752-15.638 8.685 0 15.75 7.016 15.75 15.639m-137.19-5.232c-.001-2.691-2.318-4.822-5.028-4.822h-6.053a.484.484 0 0 0-.486.483v8.939c0 .266.218.483.486.483h5.061c3.269 0 6.021-1.666 6.02-5.083m5.89-.04c0 6.702-5.503 10.032-11.609 10.032h-5.362a.484.484 0 0 0-.486.482v9.281a.485.485 0 0 1-.486.483h-4.66a.485.485 0 0 1-.486-.483V8.918c0-.267.218-.483.486-.483h10.994c6.063 0 11.61 3.202 11.61 9.734m156.64-9.734h-22.321a.482.482 0 0 0-.484.48v4.163c0 .265.216.48.484.48h7.882c.267 0 .484.215.484.48v23.929c0 .265.216.48.484.48h4.62a.482.482 0 0 0 .485-.48V14.038c0-.265.216-.48.484-.48h7.881a.482.482 0 0 0 .484-.48V8.915a.482.482 0 0 0-.483-.48m-67.512 14.9c0-6.447-4.687-9.606-10.491-9.606h-4.805a.482.482 0 0 0-.484.48v18.464c0 .265.216.48.484.48h4.805c5.804 0 10.491-3.202 10.491-9.819m5.89 0c0 10.118-7.74 15.113-16.21 15.113h-10.609a.482.482 0 0 1-.484-.48V8.915c0-.265.217-.48.484-.48h10.61c8.47 0 16.21 4.952 16.21 14.9m-46.19 9.989h-12.62a.482.482 0 0 1-.484-.48V26.12c0-.265.217-.48.483-.48h11.373a.483.483 0 0 0 .484-.48v-3.907a.482.482 0 0 0-.484-.48h-11.372a.482.482 0 0 1-.484-.48v-6.255c0-.265.217-.48.483-.48h12.406a.482.482 0 0 0 .483-.48V8.915a.482.482 0 0 0-.483-.48h-18.038a.482.482 0 0 0-.484.48v29.052c0 .265.217.48.484.48h18.252a.482.482 0 0 0 .484-.48v-4.163a.482.482 0 0 0-.483-.48m-24.9 0h-11.803a.482.482 0 0 1-.483-.48V8.915a.482.482 0 0 0-.484-.48h-4.665a.483.483 0 0 0-.484.48v29.052c0 .265.217.48.484.48h17.435a.482.482 0 0 0 .484-.48v-4.163a.482.482 0 0 0-.484-.48M16.94 18.209c-.002-2.691-2.318-4.822-5.029-4.822H5.86a.485.485 0 0 0-.486.483v8.939c0 .266.218.483.486.483h5.06c3.27 0 6.023-1.666 6.02-5.083m5.891-.04c0 6.702-5.504 10.032-11.609 10.032H5.859a.485.485 0 0 0-.486.482v9.281a.485.485 0 0 1-.487.483H.227a.485.485 0 0 1-.486-.483V8.918c0-.267.217-.483.486-.483h10.994c6.062 0 11.61 3.202 11.61 9.734m28.755-9.252V28.287c0 6.446-5.073 10.715-11.566 10.715-6.45 0-11.48-4.27-11.48-10.715V8.917c0-.266.217-.482.485-.482h4.663c.267 0 .485.216.485.482v19.199c0 3.287 2.236 5.592 5.675 5.592 3.783 0 6.106-2.39 6.106-5.592V8.917c0-.266.217-.482.484-.482h4.664c.267 0 .484.216.484.482",
    fill: "#8F17D1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M73.99 27.834c-.233.051-.351.314-.22.51a10.31 10.31 0 0 0 8.09 4.564.338.338 0 0 1 .328.335v4.856c0 .19-.16.347-.351.34a15.884 15.884 0 0 1-14.274-10.023.338.338 0 0 0-.314-.215h-2.023a.484.484 0 0 0-.486.482v9.281a.485.485 0 0 1-.487.483h-4.66a.485.485 0 0 1-.486-.483V8.918c0-.267.218-.483.487-.483h10.993c6.063 0 11.61 3.202 11.61 9.734 0 5.42-3.601 8.634-8.208 9.665M244.177 23.44c0 8.624-7.066 15.64-15.751 15.64-8.686 0-15.752-7.016-15.752-15.64 0-8.622 7.066-15.638 15.752-15.638 8.685 0 15.75 7.016 15.75 15.639M112.877 18.169c0 6.702-5.504 10.032-11.61 10.032h-5.362a.484.484 0 0 0-.486.482v9.281a.485.485 0 0 1-.486.483h-4.66a.485.485 0 0 1-.486-.483V8.918c0-.267.218-.483.486-.483h10.994c6.063 0 11.61 3.202 11.61 9.734M269.517 8.435h-22.321a.482.482 0 0 0-.484.48v4.163c0 .265.216.48.484.48h7.882c.267 0 .484.215.484.48v23.929c0 .265.216.48.484.48h4.62a.482.482 0 0 0 .485-.48V14.038c0-.265.216-.48.484-.48h7.881a.482.482 0 0 0 .484-.48V8.915a.482.482 0 0 0-.483-.48M207.896 23.334c0 10.118-7.74 15.113-16.21 15.113h-10.61a.482.482 0 0 1-.484-.48V8.915c0-.265.217-.48.484-.48h10.61c8.47 0 16.21 4.952 16.21 14.9M161.706 33.324h-12.62a.482.482 0 0 1-.484-.48V26.12c0-.265.217-.48.483-.48h11.373a.483.483 0 0 0 .484-.48v-3.907a.482.482 0 0 0-.484-.48h-11.372a.482.482 0 0 1-.484-.48v-6.255c0-.265.217-.48.483-.48h12.406a.482.482 0 0 0 .483-.48V8.915a.482.482 0 0 0-.483-.48h-18.038a.482.482 0 0 0-.484.48v29.052c0 .265.217.48.484.48h18.252a.482.482 0 0 0 .484-.48v-4.163a.482.482 0 0 0-.483-.48M136.806 33.324h-11.803a.482.482 0 0 1-.483-.48V8.915a.482.482 0 0 0-.484-.48h-4.665a.483.483 0 0 0-.484.48v29.052c0 .265.217.48.484.48h17.435a.482.482 0 0 0 .484-.48v-4.163a.482.482 0 0 0-.484-.48M22.83 18.169c0 6.702-5.504 10.032-11.609 10.032H5.859a.485.485 0 0 0-.486.482v9.281a.485.485 0 0 1-.487.483H.227a.485.485 0 0 1-.486-.483V8.918c0-.267.217-.483.486-.483h10.994c6.062 0 11.61 3.202 11.61 9.734M51.586 8.917V28.287c0 6.446-5.073 10.715-11.566 10.715-6.45 0-11.48-4.27-11.48-10.715V8.917c0-.266.217-.482.485-.482h4.663c.267 0 .485.216.485.482v19.199c0 3.287 2.236 5.592 5.675 5.592 3.783 0 6.106-2.39 6.106-5.592V8.917c0-.266.217-.482.484-.482h4.664c.267 0 .484.216.484.482"
  }))));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgLogo);

/***/ }),

/***/ 48442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V$": function() { return /* binding */ connectToParentPage; }
});

// UNUSED EXPORTS: connectToIframe, failHandshake

// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(42303);
;// CONCATENATED MODULE: ../../../../libraries/src/iframe-connect/is-controller-message.js
function is_controller_message_isControllerMessage(event) {
    var message = event.data;
    return (message === null || message === void 0 ? void 0 : message.meta) && message.data;
}
/* harmony default export */ var is_controller_message = (is_controller_message_isControllerMessage);

;// CONCATENATED MODULE: ../../../../libraries/src/iframe-connect/message-handler.js

function messageHandler(messageType, callback) {
    return function(event) {
        if (!is_controller_message(event)) {
            return;
        }
        var _data = event.data, meta = _data.meta, data = _data.data;
        if (meta.messageType === messageType) {
            callback({
                meta: meta,
                data: data
            });
        }
    };
}
/* harmony default export */ var message_handler = (messageHandler);

;// CONCATENATED MODULE: ../../../../libraries/src/iframe-connect/child-to-parent-bridge.js


function ChildToParentBridge(param) {
    var iframeId = param.iframeId, _initialData = param.initialData, initialData = _initialData === void 0 ? {} : _initialData;
    var postParentMessage = createPostFn(iframeId);
    postParentMessage("handshake-reply");
    window.addEventListener("message", message_handler("data-request", function(param) {
        var data = param.data;
        postParentMessage("data-reply", (0,_define_property/* default */.Z)({}, data.key, initialData[data.key]));
    }));
    return {
        emit: function(eventName, data) {
            postParentMessage("event", {
                eventName: eventName,
                eventData: data
            });
        },
        get: function(key) {
            return new Promise(function(resolve) {
                var dataReply = message_handler("data-reply", function(param) {
                    var data = param.data;
                    window.removeEventListener("message", dataReply, false);
                    resolve(data[key]);
                });
                window.addEventListener("message", dataReply, false);
                postParentMessage("data-request", {
                    key: key
                });
            });
        }
    };
}
function createPostFn(iframeId) {
    return function(messageType, data) {
        window.parent.postMessage({
            meta: {
                messageType: messageType,
                sourceId: iframeId
            },
            data: data || {}
        }, "*");
    };
}
/* harmony default export */ var child_to_parent_bridge = (ChildToParentBridge);

;// CONCATENATED MODULE: ../../../../libraries/src/iframe-connect/index.js





function connectToIframe(param) {
    var iframe = param.iframe, hostURL = param.hostURL, _dataRequestHandlers = param.dataRequestHandlers, dataRequestHandlers = _dataRequestHandlers === void 0 ? {} : _dataRequestHandlers;
    var iframeId = uuid();
    iframe.src = "".concat(iframe.src, "#!iframeId=").concat(iframeId);
    var connection = new Promise(function(resolve, reject) {
        function reply(event) {
            if (!isControllerMessage(event)) {
                return;
            }
            var _data = event.data, meta = _data.meta, data = _data.data;
            if (meta.sourceId !== iframeId) {
                return;
            }
            if (meta.messageType === "handshake-reply") {
                clearInterval(intervalId);
                window.removeEventListener("message", reply, false);
                resolve(ParentToChildBridge({
                    hostURL: hostURL,
                    iframeId: iframeId,
                    iframe: iframe,
                    dataRequestHandlers: dataRequestHandlers
                }));
            }
            if (meta.messageType === "handshake-failed") {
                clearInterval(intervalId);
                window.removeEventListener("message", reply, false);
                var err = new Error("Handshake to iframe failed");
                err.data = data;
                reject(err);
            }
        }
        window.addEventListener("message", reply, false);
    });
    // Emit handshake message when the iframe navigates to a
    // new page so the new page can emit messages to the parent
    iframe.addEventListener("load", function() {
        if (!iframe.src.includes("iframeId=")) {
            iframe.src = "".concat(iframe.src, "#!iframeId=").concat(iframeId);
        }
        iframe.contentWindow.postMessage({
            meta: {
                messageType: "handshake"
            },
            data: {
                iframeId: iframeId
            }
        }, hostURL);
    });
    var intervalId = setInterval(function() {
        // Because the iframe's origin is the same as the host page's until it
        // loads, postMesssage would log an error about mismatched origin. If we can
        // see that the origin is the same as the parent page, we dont try to post.
        if (isIframeSameOrigin(iframe)) {
            return;
        }
        // iframe has been removed from the page, stop trying the handshake
        if (!iframe.contentWindow) {
            clearInterval(intervalId);
            return;
        }
        iframe.contentWindow.postMessage({
            meta: {
                messageType: "handshake"
            },
            data: {
                iframeId: iframeId
            }
        }, hostURL);
    }, 100);
    return connection;
}
function connectToParentPage() {
    var parentAccessibleData = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).parentAccessibleData;
    return new Promise(function(resolve) {
        function handshake(event) {
            if (!is_controller_message(event)) {
                return;
            }
            var _data = event.data, meta = _data.meta, data = _data.data;
            if (meta.messageType === "handshake") {
                var iframeId = data.iframeId;
                if (window.location.href.includes("iframeId=".concat(iframeId)) || !window.location.href.includes("iframeId=")) {
                    window.removeEventListener("message", handshake, false);
                    var bridge = child_to_parent_bridge({
                        iframeId: data.iframeId,
                        initialData: parentAccessibleData
                    });
                    resolve(bridge);
                }
            }
        }
        window.addEventListener("message", handshake, false);
    });
}
/**
 *  failHandshake()
 *  Called from an error script served in the iframe
 */ function failHandshake(errorData) {
    function handshake(event) {
        if (!isControllerMessage(event)) {
            return;
        }
        var _data = event.data, meta = _data.meta, data = _data.data;
        if (meta.messageType === "handshake") {
            window.removeEventListener("message", handshake, false);
            postHandshakeFailMessage(data.iframeId, errorData);
        }
    }
    window.addEventListener("message", handshake, false);
}
function postHandshakeFailMessage(iframeId, data) {
    window.parent.postMessage({
        meta: {
            messageType: "handshake-failed",
            sourceId: iframeId
        },
        data: data
    }, "*");
}


/***/ }),

/***/ 574:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L6": function() { return /* reexport */ connectToPlacementParent; }
});

// UNUSED EXPORTS: getAllPlacementContainers, getPlacementContainer, getPlacementContainers, getPlacementIframe, getPlacementIframes, injectPlacementIframe

// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(18208);
// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/@juggle+resize-observer@3.4.0/node_modules/@juggle/resize-observer/lib/exports/resize-observer.js + 23 modules
var resize_observer = __webpack_require__(29515);
// EXTERNAL MODULE: ../../../../libraries/src/iframe-connect/index.js + 3 modules
var iframe_connect = __webpack_require__(48442);
;// CONCATENATED MODULE: ../../../../placement-iframe/placement-manager.ts





function injectPlacementIframe(param) {
    var hostURL = param.hostURL, src = param.src, style = param.style, dataRequestHandlers = param.dataRequestHandlers, placementType = param.placementType, instanceId = param.instanceId, _listenForResize = param.listenForResize, listenForResize = _listenForResize === void 0 ? true : _listenForResize, _allowMultiple = param.allowMultiple, allowMultiple = _allowMultiple === void 0 ? false : _allowMultiple;
    if (getPlacementIframe({
        instanceId: instanceId,
        placementType: placementType
    }) && !allowMultiple) {
        // biome-ignore lint/suspicious/noConsole: log
        console.warn("PurpleDot.load(): Placement already configured, use update() to update it.");
        return Promise.resolve();
    }
    var containerElement = getPlacementContainer({
        instanceId: instanceId,
        placementType: placementType
    });
    if (!_instanceof(containerElement, HTMLElement)) {
        return Promise.resolve();
    }
    var autoInstanceId = 1;
    if (!instanceId) {
        containerElement.dataset.purpleDotInstanceId = "".concat(autoInstanceId);
    }
    var iframe = createPlacementIframe(src, style, {
        placementType: placementType,
        instanceId: "".concat(instanceId || autoInstanceId)
    });
    updateIframeURL(iframe, src);
    containerElement.appendChild(iframe);
    return connectToIframe({
        hostURL: hostURL,
        iframe: iframe,
        dataRequestHandlers: dataRequestHandlers
    }).then(function(child) {
        var container = getPlacementContainer({
            instanceId: instanceId,
            placementType: placementType
        });
        if (!_instanceof(container, HTMLElement)) {
            return;
        }
        showIfHidden(container);
        if (listenForResize) {
            child.on("window-size-changed", function(param) {
                var width = param.width, height = param.height;
                if (height) {
                    iframe.style.height = "".concat(height, "px");
                }
                // Only apply width changes to inline-block iframes
                if (width && iframe.style.display === "inline-block") {
                    iframe.style.width = "".concat(width, "px");
                }
            });
        }
        return {
            childBridge: child,
            iframe: iframe
        };
    }).catch(function(err) {
        // biome-ignore lint/suspicious/noConsole: log
        console.error(err);
        var container = getPlacementContainer({
            instanceId: instanceId,
            placementType: placementType
        });
        if (!_instanceof(container, HTMLElement)) {
            return;
        }
        hide(container);
        var _data = err.data, reason = _data.reason, message = _data.message;
        // biome-ignore lint/suspicious/noConsole: log
        console.info("Purple Dot placement '".concat(placementType, "' not shown, reason: '").concat(reason, ": ").concat(message, "'"));
        throw err;
    });
}
function connectToPlacementParent() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return iframe_connect/* connectToParentPage.apply */.V$.apply(void 0, (0,_to_consumable_array/* default */.Z)(args)).then(function(parentBridge) {
        var elem = document.body;
        var resizeObserver = new resize_observer/* ResizeObserver */["do"](function() {
            parentBridge.emit("window-size-changed", {
                width: elem.offsetWidth,
                height: elem.offsetHeight
            });
        });
        resizeObserver.observe(elem);
        return parentBridge;
    });
}
function createPlacementIframe(src, style, param) {
    var placementType = param.placementType, instanceId = param.instanceId;
    var iframe = document.createElement("iframe");
    iframe.dataset.placementType = placementType;
    iframe.dataset.instanceId = instanceId;
    iframe.setAttribute("scrolling", "no");
    iframe.setAttribute("class", "purple-dot-frame");
    iframe.style.border = "none";
    iframe.style.width = (style === null || style === void 0 ? void 0 : style.width) || "100%";
    iframe.style.height = style && (style.initialHeight || style.height) || "54px";
    iframe.style.display = (style === null || style === void 0 ? void 0 : style.display) || "block";
    updateIframeURL(iframe, src);
    return iframe;
}
function updateIframeURL(ifrm, url) {
    ifrm.dataset.loaded = "false";
    ifrm.addEventListener("load", function() {
        // Used by Cypress when running tests to check if iframe already loaded
        ifrm.dataset.loaded = "true";
    });
    setIframeSrc(ifrm, url);
}
function setIframeSrc(ifrm, url) {
    ifrm.setAttribute("src", url);
}
function showIfHidden(el) {
    if ((el === null || el === void 0 ? void 0 : el.style.display) === "none" && el.dataset.originalDisplay) {
        el.style.display = el.dataset.originalDisplay;
    }
}
function hide(el) {
    if (!el.dataset.originalDisplay) {
        el.dataset.originalDisplay = window.getComputedStyle(el).display;
    }
    el.style.display = "none";
}

;// CONCATENATED MODULE: ../../../../placement-iframe/index.ts




/***/ }),

/***/ 936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_Branding; }
});

// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(58207);
// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52473);
// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(40891);
// EXTERNAL MODULE: ../../../../libraries/src/url/index.ts + 1 modules
var url = __webpack_require__(82052);
// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(61866);
// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/i18next@22.5.1/node_modules/i18next/dist/esm/i18next.js + 2 modules
var i18next = __webpack_require__(14719);
// EXTERNAL MODULE: ../../../../translations/index.ts
var translations = __webpack_require__(3820);
// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(9334);
// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(18208);
;// CONCATENATED MODULE: ../../../../translations/locale.ts
/** biome-ignore-all lint/suspicious/noExplicitAny: we need some shared window types */ 

var preferredLocales = {
    en: "en-US",
    en_US: "en-US",
    en_GB: "en-GB",
    es: "es-MX",
    es_MX: "es-MX",
    de: "de-DE",
    de_DE: "de-DE",
    it: "it-IT",
    it_IT: "it-IT",
    fr: "fr-FR",
    fr_FR: "fr-FR",
    nl: "nl-NL",
    nl_NL: "nl-NL"
};
function localeFromString(str) {
    if (str) {
        var localeKey = str.toLowerCase();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.entries(preferredLocales)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _value = (0,_sliced_to_array/* default */.Z)(_step.value, 2), k = _value[0], v = _value[1];
                if (localeKey === v.toLowerCase() || localeKey === k.toLowerCase()) {
                    return v;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return preferredLocales.en_US;
}
function possibleLocales() {
    var ref;
    if (!window) {
        return [
            "en"
        ];
    }
    var shopify = window.Shopify;
    var shopifyLocale = null;
    if (shopify === null || shopify === void 0 ? void 0 : shopify.locale) {
        // HACK to get around voited.fr having a broken country selector
        if (isVoited() && shopify.locale.startsWith("fr")) {
            shopifyLocale = "fr-FR";
        } else if (shopify.locale.includes("-")) {
            shopifyLocale = shopify.locale;
        } else if (shopify.country) {
            shopifyLocale = "".concat(shopify.locale, "-").concat(shopify.country);
        } else {
            shopifyLocale = shopify.locale;
        }
    }
    var queryParamLocale = new URLSearchParams(window.location.search).get("locale");
    return [
        queryParamLocale,
        (ref = window.PurpleDotConfig) === null || ref === void 0 ? void 0 : ref.locale,
        shopifyLocale,
        document.documentElement.lang, 
    ].concat((0,_to_consumable_array/* default */.Z)(navigator.languages), [
        "en", 
    ]).filter(function(l) {
        return l != null;
    });
}
// HACK to get around voited.fr having a broken country selector
// This dupes code from shopify-script package but I am trying to avoid
// creating a circular dependency for what is a temp hack
function isVoited() {
    var ref;
    var ref1;
    return [
        "voited-eu.myshopify.com",
        "voited-de.myshopify.com",
        "voited-fr.myshopify.com",
        "voited-uk.myshopify.com",
        "voited1.myshopify.com", 
    ].includes((ref1 = (ref = window.Shopify) === null || ref === void 0 ? void 0 : ref.shop) !== null && ref1 !== void 0 ? ref1 : "");
}
function autoDetectLocale() {
    return localeFromString(possibleLocales()[0]);
}

;// CONCATENATED MODULE: ../../../../translations/i18n.ts





// Configure a backend that loads translations asynchronously.
// This works using webpack code splitting to load translations on demand.
// We only load the badly named "shopify" namespace because it contains
// the specific frontend translations.
var i18nLoading = i18next/* default.isInitialized */.ZP.isInitialized ? Promise.resolve() : i18next/* default.use */.ZP.use({
    type: "backend",
    read: function read(language, namespace, callback) {
        (0,translations/* loadAsync */.vA)(language, namespace).then(function(resources) {
            callback(null, resources);
        }).catch(function(error) {
            callback(error, null);
        });
    }
}).use({
    type: "languageDetector",
    detect: function detect() {
        return autoDetectLocale();
    }
}).init((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, translations/* baseConfig */.uN), {
    ns: [
        "shopify"
    ],
    lng: undefined
}));
// Give the translations up to 5 seconds to load before giving up and just rendering anyway
var i18nReady = Promise.race([
    i18nLoading.catch(function(error) {
        // biome-ignore lint/suspicious/noConsole: log
        console.error(error);
    }),
    new Promise(function(resolve) {
        setTimeout(resolve, 5000);
    }), 
]);
var t = i18next/* default.getFixedT */.ZP.getFixedT(null, "shopify");
var addResourceBundle = i18next/* default.addResourceBundle.bind */.ZP.addResourceBundle.bind(i18next/* default */.ZP);

;// CONCATENATED MODULE: ../../../../web-components/learn-more/learn-more-modal.ts




function createLearnMoreButton() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _HOST = ref.HOST, HOST = _HOST === void 0 ? "https://www.purpledotprice.com" : _HOST, _hideBackToProduct = ref.hideBackToProduct, hideBackToProduct = _hideBackToProduct === void 0 ? false : _hideBackToProduct, _isAddToPreorder = ref.isAddToPreorder, isAddToPreorder = _isAddToPreorder === void 0 ? false : _isAddToPreorder, _useExtendedDeliveryLanguage = ref.useExtendedDeliveryLanguage, useExtendedDeliveryLanguage = _useExtendedDeliveryLanguage === void 0 ? false : _useExtendedDeliveryLanguage, _storeIdentifier = ref.storeIdentifier, storeIdentifier = _storeIdentifier === void 0 ? getStoreIdentifier() : _storeIdentifier;
    var createOverlayIframe = function createOverlayIframe(param) {
        var id = param.id, src = param.src;
        var iframe = document.createElement("iframe");
        iframe.id = id;
        iframe.src = src;
        iframe.style.position = "fixed";
        iframe.style.top = "0";
        iframe.style.left = "0";
        iframe.style.bottom = "0";
        iframe.style.right = "0";
        iframe.style.width = "100%";
        iframe.style.height = "100%";
        iframe.style.zIndex = "2147483647";
        return iframe;
    };
    var learnMoreIframeSrc = function learnMoreIframeSrc(param) {
        var iframeCommsId = param.iframeCommsId, isAddToPreorder = param.isAddToPreorder, storeIdentifier = param.storeIdentifier, useExtendedDeliveryLanguage = param.useExtendedDeliveryLanguage;
        return (0,url/* createURL */.Ri)({
            host: HOST,
            path: "/embedded-checkout/pre-order-value-prop",
            queryParams: (0,_object_spread/* default */.Z)({
                hideBackToProduct: hideBackToProduct,
                locale: autoDetectLocale(),
                isAddToPreorder: isAddToPreorder,
                useExtendedDeliveryLanguage: useExtendedDeliveryLanguage
            }, storeIdentifier),
            hash: "#!iframeId=".concat(iframeCommsId)
        });
    };
    var learnMoreBtn = document.createElement("span");
    learnMoreBtn.innerHTML = t("shopify:shopify-app.learn-more");
    learnMoreBtn.style.textDecoration = "underline";
    learnMoreBtn.style.cursor = "pointer";
    learnMoreBtn.style.background = "none";
    learnMoreBtn.style.border = "none";
    learnMoreBtn.addEventListener("click", function() {
        var onMessage = function onMessage(ev) {
            var data = ev.data;
            if (!data) {
                return;
            }
            if (data.meta && data.meta.messageType === "handshake-reply") {
                clearInterval(interval);
                return;
            }
            if (data.data && data.data.eventName === "dismiss-iframe") {
                var dismissIframe = document.querySelector("#".concat(id));
                if (dismissIframe) {
                    var ref;
                    (ref = dismissIframe.parentNode) === null || ref === void 0 ? void 0 : ref.removeChild(dismissIframe);
                }
            }
        };
        var sendHandshake = function sendHandshake() {
            var ref;
            if (!iframe) {
                return;
            }
            (ref = iframe.contentWindow) === null || ref === void 0 ? void 0 : ref.postMessage({
                meta: {
                    messageType: "handshake"
                },
                data: {
                    iframeId: iframeCommsId
                }
            }, HOST);
        };
        var iframeCommsId = "d323029f-c21e-458b-9a73-957e7d87db32";
        var id = "pd-learn-more-iframe";
        var iframe = createOverlayIframe({
            id: id,
            src: learnMoreIframeSrc({
                iframeCommsId: iframeCommsId,
                isAddToPreorder: isAddToPreorder,
                storeIdentifier: storeIdentifier,
                useExtendedDeliveryLanguage: useExtendedDeliveryLanguage
            })
        });
        document.body.appendChild(iframe);
        var interval = setInterval(sendHandshake, 500);
        window.addEventListener("message", onMessage, false);
    });
    return learnMoreBtn;
}
function getStoreIdentifier() {
    var ref, ref1;
    if ((ref = window.PurpleDotConfig) === null || ref === void 0 ? void 0 : ref.apiKey) {
        var ref2;
        return {
            apiKey: (ref2 = window.PurpleDotConfig) === null || ref2 === void 0 ? void 0 : ref2.apiKey
        };
    }
    if ((ref1 = window.Shopify) === null || ref1 === void 0 ? void 0 : ref1.shop) {
        var ref3;
        return {
            shop: (ref3 = window.Shopify) === null || ref3 === void 0 ? void 0 : ref3.shop
        };
    }
    return {};
}

// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(29342);
// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/styled-components@5.3.11_@babel+core@7.27.3_react-dom@18.3.1_react@18.3.1__react-is@18.3.1_react@18.3.1/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(1578);
// EXTERNAL MODULE: ./components/use-translation.ts + 7 modules
var use_translation = __webpack_require__(88724);
;// CONCATENATED MODULE: ./components/common/Branding.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  width: 100%;\n\n  .text {\n    @media (max-width: 750px) {\n      font-size: ",
        ";\n      line-height: ",
        ";\n    }\n    color: var(--text-color-secondary);\n  }\n\n  .purple:before {\n    display: inline-block;\n    position: relative;\n    content: ' ';\n    border-radius: 50%;\n    width: 8px;\n    height: 8px;\n    bottom: 1px;\n    background-color: ",
        ";\n  }\n\n  .purple {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Branding = (0,styled_components_browser_esm/* default */.ZP)(function(param) {
    var className = param.className, _useExtendedDeliveryLanguage = param.useExtendedDeliveryLanguage, useExtendedDeliveryLanguage = _useExtendedDeliveryLanguage === void 0 ? false : _useExtendedDeliveryLanguage, storeId = param.storeId;
    var t = (0,use_translation/* useTranslation */.$)().t;
    var textContainer = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var ref;
        var learnMoreButton = createLearnMoreButton({
            HOST: getOrigin(),
            hideBackToProduct: true,
            useExtendedDeliveryLanguage: useExtendedDeliveryLanguage,
            storeIdentifier: {
                storeId: storeId
            }
        });
        learnMoreButton.setAttribute("data-testid", "learn-more-button");
        learnMoreButton.setAttribute("class", "text");
        (ref = textContainer.current) === null || ref === void 0 ? void 0 : ref.appendChild(learnMoreButton);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            className: "text",
            ref: textContainer,
            children: [
                useExtendedDeliveryLanguage ? t("translation:self-service.common.extended-delivery-protected-by") : t("translation:self-service.common.waitlist-protected-by"),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "purple",
                    children: " Purple Dot"
                }),
                ".",
                " "
            ]
        })
    });
}).withConfig({
    componentId: "sc-5af91e9e-0"
})(_templateObject(), function(param) {
    var forCheckout = param.forCheckout;
    return forCheckout ? "14px" : "auto";
}, function(param) {
    var forCheckout = param.forCheckout;
    return forCheckout ? "22px" : "auto";
}, function(param) {
    var theme = param.theme;
    return theme.pdLogo.color;
}, function(param) {
    var theme = param.theme;
    return theme.pdLogo.color;
});
function getOrigin() {
    return window.location.origin;
}
/* harmony default export */ var common_Branding = (Branding);


/***/ }),

/***/ 57947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58207);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1578);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: none;\n  transition: all 0.3s linear;\n\n  text-transform: uppercase;\n\n  background-color: ",
        ";\n  color: ",
        ";\n  letter-spacing: ",
        ";\n\n  &:disabled {\n    color: ",
        ";\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ThemedButton = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-9f58f06c-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.button.enabled.backgroundColor;
}, function(param) {
    var theme = param.theme;
    return theme.button.enabled.color;
}, function(param) {
    var theme = param.theme;
    return theme.button.enabled.letterSpacing;
}, function(param) {
    var theme = param.theme;
    return theme.button.disabled.color;
}, function(param) {
    var theme = param.theme;
    return theme.button.disabled.backgroundColor;
});
/* harmony default export */ __webpack_exports__["Z"] = (ThemedButton);


/***/ }),

/***/ 23096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ shopper_ShopperPage; }
});

// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52473);
// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/next@12.3.7_@babel+core@7.27.3_babel-plugin-macros@3.1.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/head.js
var head = __webpack_require__(98363);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/next@12.3.7_@babel+core@7.27.3_babel-plugin-macros@3.1.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/router.js
var next_router = __webpack_require__(45511);
// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(29342);
// EXTERNAL MODULE: ./components/common/base-page.jsx
var base_page = __webpack_require__(98322);
// EXTERNAL MODULE: ./components/common/config-context.tsx
var config_context = __webpack_require__(98103);
// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(42303);
// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/next@12.3.7_@babel+core@7.27.3_babel-plugin-macros@3.1.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dynamic.js
var dynamic = __webpack_require__(88744);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/shopper/ShopperFAQ.tsx




var _obj;
var TypeFormWidget = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7245).then(__webpack_require__.t.bind(__webpack_require__, 87245, 23)).then(function(mod) {
        return mod.Sidetab;
    });
}, (_obj = {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(87245)
            ];
        }
    }
}, (0,_define_property/* default */.Z)(_obj, "loadableGenerated", {
    webpack: function webpack() {
        return [
            /*require.resolve*/(87245)
        ];
    }
}), (0,_define_property/* default */.Z)(_obj, "ssr", false), _obj));
function ShopperFAQ() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TypeFormWidget, {
        id: "avSmu8nj",
        buttonText: "Get help"
    });
}

;// CONCATENATED MODULE: ./components/shopper/ShopperPage.jsx
/* eslint react/no-unescaped-entities: "off" */ 






function ShopperPage(param) {
    var pageName = param.pageName, _title = param.title, title = _title === void 0 ? "Find your pre-order" : _title, titleSuffix = param.titleSuffix, noIndex = param.noIndex, _description = param.description, description = _description === void 0 ? "Find your pre-order, update your shipping address or cancel your pre-order" : _description, embedded = param.embedded, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(base_page/* default */.Z, {
        pageName: pageName,
        title: title,
        titleSuffix: titleSuffix,
        description: description,
        noIndex: noIndex,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VisitorHead, {}),
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HideForEmbedded, {
                embedded: embedded,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopperFAQ, {})
            })
        ]
    });
}
function HideForEmbedded(param) {
    var children = param.children, embedded = param.embedded;
    return embedded ? null : children;
}
function VisitorHead() {
    var router = (0,next_router.useRouter)();
    var host = (0,config_context/* useConfig */.Z)().host;
    var canonical = host ? "".concat(host).concat(router.asPath.split("?")[0]) : undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preconnect",
                href: "https://purple-dot.imgix.net"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preconnect",
                href: "https://config.gorgias.io"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preconnect",
                href: "https://www.googletagmanager.com"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preconnect",
                href: "https://www.googleadservices.com"
            }),
            canonical && /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "canonical",
                href: canonical
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "\n          @font-face {\n            font-family: 'Jungka';\n            font-weight: 300;\n            font-display: auto;\n            src: url('https://www.purpledotprice.com/static/webfonts/Jungka-Book.woff2') format('woff2'),\n                url('https://www.purpledotprice.com/static/webfonts/Jungka-Book.woff') format('woff');\n          }\n\n          @font-face {\n            font-family: 'Jungka';\n            font-weight: 400;\n            font-display: auto;\n            src: url('https://www.purpledotprice.com/static/webfonts/Jungka-Regular.woff2') format('woff2'),\n              url('https://www.purpledotprice.com/static/webfonts/Jungka-Regular.woff') format('woff');\n          }\n\n          @font-face {\n            font-family: 'Jungka';\n            font-weight: normal;\n            font-style: italic;\n            font-display: auto;\n            src: url('https://www.purpledotprice.com/static/webfonts/Jungka-RegularItalic.woff2') format('woff2'),\n                url('https://www.purpledotprice.com/static/webfonts/Jungka-RegularItalic.woff') format('woff');\n          }\n\n          @font-face {\n            font-family: 'Jungka';\n            font-weight: bold;\n            font-style: normal;\n            font-display: auto;\n            src: url('https://www.purpledotprice.com/static/webfonts/Jungka-Bold.woff2') format('woff2'),\n                url('https://www.purpledotprice.com/static/webfonts/Jungka-Bold.woff') format('woff');\n          }\n\n          @font-face {\n            font-family: 'Jungka';\n            font-weight: bold;\n            font-style: italic;\n            font-display: auto;\n            src: url('https://www.purpledotprice.com/static/webfonts/Jungka-BoldItalic.woff2') format('woff2'),\n                url('https://www.purpledotprice.com/static/webfonts/Jungka-BoldItalic.woff') format('woff');\n          }\n\n          @font-face {\n            font-family: 'Jungka-Book';\n            src: url('https://www.purpledotprice.com/static/webfonts/Jungka-Book.woff2') format('woff2'),\n                url('https://www.purpledotprice.com/static/webfonts/Jungka-Book.woff') format('woff');\n          }\n\n          @font-face {\n            font-family: 'Jungka-Regular';\n            src: url('https://www.purpledotprice.com/static/webfonts/Jungka-Regular.woff2') format('woff2'),\n                url('https://www.purpledotprice.com/static/webfonts/Jungka-Regular.woff') format('woff');\n          }\n\n          @font-face {\n            font-family: 'Jungka-Bold';\n            src: url('https://www.purpledotprice.com/static/webfonts/Jungka-Bold.woff2') format('woff2'),\n                url('https://www.purpledotprice.com/static/webfonts/Jungka-Bold.woff') format('woff');\n          }\n        "
            })
        ]
    });
}
/* harmony default export */ var shopper_ShopperPage = (ShopperPage);


/***/ }),

/***/ 75984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58207);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1578);
/* harmony import */ var _common_ThemedButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57947);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 12px 36px;\n\n  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n  \n  &:hover {\n    text-decoration: none;\n    box-shadow: 0 10px 10px -5px rgba(0, 0, 0, 0.3),\n      0 10px 10px -5px rgba(143, 23, 209, 0.4);\n  }\n  \n  :disabled:hover {\n    box-shadow: none;\n  }\n  \n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ShopperThemedButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_common_ThemedButton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-9ed0e0fd-0"
})(_templateObject(), function(param) {
    var _embedded = param.embedded, embedded = _embedded === void 0 ? false : _embedded;
    return !embedded && "\n      text-transform: none;\n\n      border-radius: 29px;\n      border: 2px solid ".concat(function(param) {
        var theme = param.theme;
        return theme.button.enabled.backgroundColor;
    }, ";\n\n      font-size: 14px;\n\n      line-height: 14px;\n      letter-spacing: 0.8px;\n  ");
});
/* harmony default export */ __webpack_exports__["Z"] = (ShopperThemedButton);


/***/ })

}]);